import axiosInstance from "app/axios";
import { AxiosResponse } from "axios";
import { UserRoles } from "interfaces/UserRoles";
import { TaxationKind } from '../../interfaces/TaxationKind';

export interface FetchTaxationKindsResponse {
  data: {
    taxation_kinds: TaxationKind[];
  }
  // Add other potential response properties like total, page, etc. if your API returns them
}

export const fetchTaxationKindsAPI = async (endpoint = UserRoles.Admin): Promise<AxiosResponse<FetchTaxationKindsResponse, any>> => {
  return axiosInstance.get(`${endpoint}/taxation_kinds`, {
    params: {
      items_per_page: 'unlimited',
    }
  });

};
